import { Images } from '../../../../shared/app-constants';
import MasterLog from '../../../../shared/enums/master-log-enum';
import { getIsRequestPending } from '../../../../shared/utils/get-request-status';
import {
  EmailCategoryOption,
  EmailCategoryType,
  ReplyForwardEmailPreview,
} from '../../type';

export const getUnifiedInboxActivityLabel = (tab: MasterLog): string => {
  if (tab === MasterLog.UniboxEmailOpened) {
    return 'opened';
  }
  if (tab === MasterLog.UniboxEmailLinkClicked) {
    return 'clicked';
  }
  return '';
};

export const getUnifiedInboxActivityIcon = (
  key: MasterLog,
  active: boolean,
) => {
  switch (key) {
    case MasterLog.UniboxEmailOpened:
      return active ? Images.OpenedBlue : Images.OpenedEnabled;
    case MasterLog.UniboxEmailLinkClicked:
      return active ? Images.ClickedBlue : Images.ClickedEnabled;
    default:
      break;
  }
  return null;
};

export const getProspectEmail = (selectedEmail: ReplyForwardEmailPreview) => {
  if (selectedEmail.toProspectId) {
    return selectedEmail.to?.[0];
  }
  if (selectedEmail.fromProspectId) {
    return selectedEmail.fromEmail;
  }

  return '';
};

export const getEmailCategoriesForThreadsAssignment = (
  emailCategories: EmailCategoryType[],
): EmailCategoryOption[] => {
  if (!emailCategories || emailCategories.length === 0) {
    return [];
  }

  return emailCategories.map((item) => ({ key: item.id.toString(), ...item }));
};

export const isAnyBulkActionPending = ({
  updateEmailBulkActionsRequestStatus,
  bulkMarkAsReadUnreadRequestStatus,
}) =>
  getIsRequestPending(updateEmailBulkActionsRequestStatus) ||
  getIsRequestPending(bulkMarkAsReadUnreadRequestStatus);
